import * as t from "io-ts";

export const WelcomeSkipBanner = t.partial({
  director_verification: t.union([t.literal("yes"), t.literal("no")]),
  invite_team_member: t.union([t.literal("yes"), t.literal("no")]),
  update_website: t.union([t.literal("yes"), t.literal("no")]),
  advert_finance_calculator: t.union([t.literal("yes"), t.literal("no")]),
});

export interface WelcomeSkipBanner {
  director_verification?: "yes" | "no";
  invite_team_member?: "yes" | "no";
  update_website?: "yes" | "no";
  advert_finance_calculator?: "yes" | "no";
}
